import { merge, Stack } from '@fluentui/react';
import React, { useMemo } from 'react';
import background from '../../../assets/background.png';
import actualites from '../../../assets/pictos/actualites.svg';
import adf from '../../../assets/pictos/adf.svg';
import autres from '../../../assets/pictos/autres.svg';
import documents from '../../../assets/pictos/documents.svg';
import logement from '../../../assets/pictos/logement.svg';
import messagerie from '../../../assets/pictos/messagerie.svg';
import { ResponsiveSize, useResponsiveSize } from '../../../contexts/responsiveContext';
import Pictogramme from './Pictogramme';
import Title from './Title';

const Pictogrammes = () => {

    const { responsiveSize } = useResponsiveSize();

    const styles = useMemo(
        () => {
            let styles = {
                outer: {
                    root: {
                        backgroundImage: `url(${background})`,
                        backgroundPosition: "right bottom",
                        backgroundSize: 645,
                        boxShadow: "inset 220px 0px 75px rgba(0, 0, 0, 0.5)",
                        minHeight: 365,
                        padding: 24,
                        selectors: {
                            "@media(min-width:645px)": {
                                backgroundSize: "cover",
                                backgroundPositionY: "center",
                            }
                        }
                    }
                },
                pictos: {
                    inner: {
                        gap: "18px 25px",
                        minWidth: 315,
                        width: 315
                    }
                },
            };

            if (responsiveSize >= ResponsiveSize.medium)
                styles = merge(
                    styles,
                    {
                        outer: {
                            root: {
                                background: "rgb(0, 0, 0, 0.25)",
                                height: 498,
                                padding: 34,
                                width: 379,
                            }
                        },
                        pictos: { inner: { gap: "27px 39px" } },
                    }
                );

            return styles;
        },
        [responsiveSize]
    );

    const pictogrammes = [
        { src: actualites, label: "Actualités du chantier" },
        { src: logement, label: "Mon logement" },
        { src: messagerie, label: "Messagerie dédiée" },
        { src: documents, label: "Espace Documents" },
        { src: adf, label: "Appels de fonds" },
        { src: autres, label: "Autres..." },
    ];

    return <Stack styles={styles.outer} tokens={{ childrenGap: 15 }} >
        {responsiveSize === ResponsiveSize.small && <Title />}
        <Stack horizontal styles={styles.pictos} wrap>
            {pictogrammes.map((pictogramme, index) => {
                const { src, label } = pictogramme;
                return <Pictogramme key={index} src={src} label={label} />;
            })}
        </Stack>
    </Stack>;

};

export default Pictogrammes;